import React, { useEffect } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { isBackgroundDark } from '../services/themeBuilder';

export default function BookingConfirmationPage() {
  const location = useLocation();
  const { name, phone } = location.state || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const isDarkBg = isBackgroundDark(theme.palette.background.default);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function formatPhoneNumber(phone: string): string {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phone;
  }

  return (
    <>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 8 }}>
        <Box p={4} maxWidth="600px" mx="auto" textAlign="center">
          <Typography 
            variant="h4" 
            gutterBottom
            sx={{ color: isDarkBg ? '#FFFFFF' : 'text.primary' }}
          >
            🎉 You're Booked, {name || 'Friend'}!
          </Typography>

          <Typography 
            variant="body1" 
            gutterBottom
            sx={{ color: isDarkBg ? '#FFFFFF' : 'text.primary' }}
          >
            Thanks for booking! We've sent a confirmation email with the details of your appointment.
          </Typography>
          
          <Button
            onClick={() => navigate(-1)}
            variant="contained"
            sx={{ mt: 4 }}
          >
            Back
          </Button>
        </Box>
      </Box>
    </>
  );
}
